import{AutoPopulateBehavior as r}from"./auto-populate-behavior";import{BehaviorRegistry as o}from"./behavior-registry";const e=new o;e.register(r);const a=e;export{a as defaultBehaviorRegistry};
